// Credentials remain in component memory for this one signup/login handoff.
// Never write the signed proof or generated password to browser storage.
export function isGoogleSignupDiscovery(data) {
  return !data?.errors && data?.data?.loginUser?.userName === 'username' &&
    data?.data?.loginUser?.userEmail === 'userEmail';
}
export function googleSignupCredentials(proof, email, crypto) {
  if ((!proof?.idToken && !proof?.socialAuthProof) || !proof?.loginNonce || proof.email !== email || !crypto?.getRandomValues)
    throw new Error('Restart social sign-up from its provider button.');
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  return { password: Array.from(bytes, value => value.toString(16).padStart(2, '0')).join(''),
    socialProvider: proof.provider, socialProviderId: proof.providerId,
    ...(proof.provider === 'google' ? { googleIdToken: proof.idToken, googleLoginNonce: proof.loginNonce }
      : { socialAuthProof: proof.socialAuthProof, socialLoginNonce: proof.loginNonce }) };
}
